import { Component, OnInit, DoCheck, Input } from '@angular/core';
import { Societe, statuts, fonctions, civilities, Signataire } from '../../models/societe';
import { StatutSociete } from '../../models/statutsociete';
import { SocieteService } from '../../services/societe.service';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { StateService } from '../../services/state/state.service';
import { MatDialog } from '@angular/material';
import { PopinComponent } from '../utils/popin/popin.component';
import { User } from '../../models/user';

import { Store } from '@ngrx/store';
import * as fromRoot from '../../common/appstore/index';
import * as layout from '../../common/appstore/actions';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const PHONENUMBER_REGEX = /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/;



@Component({
  selector: 'step-societe',
  templateUrl: './societe.component.html',
  styleUrls: ['./societe.component.scss']
})
export class SocieteComponent implements OnInit {
  fonctions = fonctions;
  civilities = civilities;
  societe: Societe;
  clientForm: FormGroup;
  signataireForm: FormGroup;
  societeForm: FormGroup;
  societes: Societe[] = [];
  signataire: Signataire[] = [];
  listsocieteready: boolean = false;
  //societeselected: Societe[] = [];

  @Input() type;
  @Input() currentsociete;
  @Input() currentdocument;
  @Input() currentsignataire;
  @Input() currentuser: User;
  
  constructor(
    private servicesociete: SocieteService,
    private fb: FormBuilder, 
    private servicestate: StateService,
    public dialog: MatDialog,
    public store: Store<fromRoot.AppState>
  ) {
    this.createFormClient();
  }

  ngOnInit() {
    this.getListSociete();
    this.initSociete();
    this.initForms(this.currentuser);
  }

  createFormClient(){
    this.clientForm = this.fb.group({
      societeForm: this.fb.group({
        id: 0,
        commercial_id: '',
        ines_id: new FormControl(),
        statut: new FormControl(statuts[0].toString()),
        raisonsociale: new FormControl(),
        enseigne: new FormControl(),
        siret: new FormControl(),
        urlsite: new FormControl(),
        adresseGroup: this.fb.group({
          id: new FormControl(),
          adresse: new FormControl(),
          postal_code: new FormControl(),
          locality: new FormControl(),
          country: new FormControl()
        }),
        email: new FormControl('', [
          Validators.required,
          Validators.pattern(EMAIL_REGEX)
        ]),
        tel: new FormControl('', [
          Validators.required,
          Validators.pattern(PHONENUMBER_REGEX)
        ]),
        fax: new FormControl()
      }),
      
      useSocieteFormForFacturation: true,

      facturationForm: this.fb.group({
        id: 0,
        ines_id: new FormControl(),
        statut: new FormControl(statuts[0].toString()),
        raisonsociale: new FormControl(),
        enseigne: new FormControl(),
        siret: new FormControl(),
        urlsite: new FormControl(),
        adresseGroup: new FormGroup({
          id: new FormControl(),
          adresse: new FormControl(),
          postal_code: new FormControl(),
          locality: new FormControl(),
          country: new FormControl()
        }),
        email: new FormControl('', [
          Validators.required,
          Validators.pattern(EMAIL_REGEX)
        ]),
        tel: new FormControl('', [
          Validators.required,
          Validators.pattern(PHONENUMBER_REGEX)
        ]),
        fax: new FormControl()
      }),

      signataireForm: this.fb.group({
        id: 0,
        ines_id: new FormControl(),
        civilite: new FormControl(civilities[0].toString()),
        nom: new FormControl(),
        prenom: new FormControl(),
        fonction: new FormControl(fonctions[0].toString()),
        email: new FormControl('', [
          Validators.required,
          Validators.pattern(EMAIL_REGEX)
        ]),
        tel: new FormControl('', [
          Validators.required,
          Validators.pattern(PHONENUMBER_REGEX)
        ])
      })
    });
  
  }

  onSubmit(){
    let docstate = this.currentdocument;
    let societestate = this.currentsociete;
    console.log('state societe : ' + societestate);
    if (societestate){
      
      this.servicesociete.saveSociete(this.clientForm.value.societeForm, this.clientForm.value.signataireForm, docstate);

    } else {
      console.log('state societe 2 : ' + societestate);
      this.clientForm.patchValue({
        societeForm: {
          id: societestate.id
        }
      });

      let signatairestate = this.currentsignataire;

      if (!!signatairestate){
        this.clientForm.patchValue({
          signataireForm: {
            id: signatairestate.id
          }
        });
      }

      console.log(signatairestate.id);

      this.servicesociete.updateSociete(this.clientForm.value.societeForm, this.clientForm.value.signataireForm, docstate);
    }

  }

  checkValidForm(){
    return false;
    /*if (this.clientForm.value.useSocieteFormForFacturation){
      return !(this.clientForm.controls.societeForm.valid && this.clientForm.controls.signataireForm.valid);
    }
    return !this.clientForm.valid;*/
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(PopinComponent, {
      width: '50%',
      data: this.societes
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result){
        this.adresseGroupValues(result);
        this.clientForm.patchValue({
          societeForm:{
            id: result.id
          }
        });
        this.store.dispatch(new layout.AddSociete(result));
        this.store.dispatch(new layout.AddSignataire(result.signataire));
        this.currentsociete = result;
        this.signataire = result.signataire;
      }
    });
  }

  protected adresseGroupValues(result:any) {
    this.clientForm.controls.societeForm.patchValue({
      adresseGroup: {
        id: result.place_id,
        adresse: result.adresse,
        postal_code: result.postal_code,
        country: result.country,
        locality: result.locality
      }
    });
  }

  getListSociete(): void{
    this.servicesociete.getAllSociete().subscribe(societes => {
      this.societes = societes;
      this.listsocieteready = true;
    });
  }

  initForms(user: User){
    this.clientForm.patchValue({
      societeForm:{
        commercial_id: user.id
      }
    });
  }

  initSociete(){
    if (!!this.currentsociete){
      this.adresseGroupValues(this.currentsociete);
      this.signataire = this.currentsociete.signataire;
      return this.currentsociete;
    }
    this.currentsociete = [];
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/societe/societe.component.ts